// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalStyle_modal__E2Yog","img":"ModalStyle_img__20kF1"};